import { Link } from 'react-router-dom';
import './LegalPageLayout.css';

interface LegalPageLayoutProps {
  title: string;
  children: React.ReactNode;
}

export function LegalPageLayout({ title, children }: LegalPageLayoutProps) {
  return (
    <div className="legal-page">
      <nav className="legal-nav" aria-label="Site navigation">
        <Link to="/" className="legal-nav-logo">
          <svg
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            aria-hidden="true"
          >
            <rect width="32" height="32" rx="6" fill="#1e4d3e" />
            <path
              d="M9 11h5v10H9zM18 11h5v10h-5zM9 16h14"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
          Hire It Now
        </Link>
        <span className="legal-nav-sep" aria-hidden="true">/</span>
        <span className="legal-nav-title">{title}</span>
      </nav>
      <main className="legal-content" id="main-content">
        {children}
      </main>
    </div>
  );
}
